import { useMutation } from '../../lib';
import { useTribeClient } from '../../useTribeClient';
export const useVerifyMember = (options) => {
    const { useMutationOptions, fields = 'default' } = options || {};
    const { client } = useTribeClient();
    return useMutation((input) => client.auth.verifyMember(input, fields), useMutationOptions);
};
//# sourceMappingURL=useVerifyMember.js.map